export default __webpack_public_path__ + "static/media/bmp.751e3f08.svg";